import { useMemo } from 'react'

import {
  OrderItemType,
  OrderListItem,
  OrderStatus,
  useGetOrdersQuery,
} from 'src/Redux/artistOrderApi'

const BLOCKING_STATUSES = [
  OrderStatus.Checkout,
  OrderStatus.PaymentSent,
  OrderStatus.Paid,
]

export type ConflictingOrderResult = {
  order: OrderListItem | undefined
  isFetching: boolean
}

export const useFindConflictingOrder = (
  type: OrderItemType,
  sourceId: number,
  excludeOrderId?: number,
): ConflictingOrderResult => {
  const { data: orders, isFetching } = useGetOrdersQuery()

  const order = useMemo(
    () =>
      orders?.find(
        (candidate) =>
          candidate.id !== excludeOrderId &&
          BLOCKING_STATUSES.includes(candidate.status) &&
          candidate.items.some(
            (item) => item.type === type && item.sourceId === sourceId,
          ),
      ),
    [orders, type, sourceId, excludeOrderId],
  )

  return { order, isFetching }
}
